var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"more-button clear no-border"},[_c('MoreIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }